import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { DateTime } from 'luxon';
import { initReactI18next } from 'react-i18next';
import { getEnv } from '~/src/dash/resellers/utils/importResellerConfig';

import { enTranslation } from '~/src/locales/en';
import { jaTranslation } from '~/src/locales/ja';

void i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  // .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: getEnv() !== 'prod',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: (value, format, lng) => {
        if (value instanceof Date) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
          return DateTime.fromJSDate(value).setLocale(lng).toLocaleString(DateTime[format]);
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return value;
      },
    },
    resources: {
      // IMPORTANT: if you add a new language, you must also edit src/locales/common.ts
      en: enTranslation,
      ja: jaTranslation,
    },
  });

export default i18n;

// SAVE FOR NOTES

// /* language */
// i18next.language;
// // Is set to the current detected or set language.

// /* languages */
// i18next.languages;
// // Is set to an array of language codes that will be used to look up the translation value.
// // When the language is set, this array is populated with the new language codes.
// // Unless overridden, this array is populated with less-specific versions of that code for fallback purposes, followed by the list of fallback languages

// // initialize with fallback languages
// i18next.init({
//   fallbackLng: ["es", "fr", "en-US", "dev"]
// });
// // change the language
// i18next.changeLanguage("en-US-xx");
// // new language and its more generic forms, followed by fallbacks
// i18next.languages; // ["en-US-xx", "en-US", "en", "es", "fr", "dev"]
// // change the language again
// i18next.changeLanguage("de-DE");
// // previous language is not retained
// i18next.languages; // ["de-DE", "de", "es", "fr", "en-US", "dev"]

// /* resolvedLanguage */
// i18next.resolvedLanguage;
// // Is set to the current resolved language.
// // It can be used as primary used language,
// // for example in a language switcher.

// // translation resources:
// {
//   "key_zero": "zero",
//   "key_one": "singular",
//   "key_two": "two",
//   "key_few": "few",
//   "key_many": "many",
//   "key_other": "other"
// }

// // usage:
// t('key', {count: 0}); // -> "zero"
// t('key', {count: 1}); // -> "singular"
// t('key', {count: 2}); // -> "two"
// t('key', {count: 3}); // -> "few"
// t('key', {count: 4}); // -> "few"
// t('key', {count: 5}); // -> "few"
// t('key', {count: 11}); // -> "many"
// t('key', {count: 99}); // -> "many"
// t('key', {count: 100}); // -> "other"
